var _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFileUploadIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 45,
    viewBox: "0 0 45 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.5002 22.3961V38.8961M22.5002 22.3961L17.9169 26.0628M22.5002 22.3961L27.0835 26.0628M9.72921 17.1106C7.99527 17.5469 6.48032 18.6014 5.46901 20.0759C4.4577 21.5504 4.01963 23.3435 4.23711 25.1182C4.45459 26.8929 5.31265 28.5272 6.65007 29.7139C7.98749 30.9006 9.71222 31.558 11.5002 31.5628H13.3335",
    stroke: "#121212",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M29.5219 13.4824C28.8953 11.0011 27.3486 8.85091 25.1954 7.46769C23.0423 6.08447 20.4437 5.57171 17.9265 6.03337C15.4093 6.49503 13.1618 7.89655 11.6397 9.95384C10.1175 12.0111 9.43452 14.5702 9.72921 17.1124C9.72921 17.1124 10.0097 18.7294 10.5835 19.646",
    stroke: "#121212",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M31.6673 31.5627C32.9617 31.5618 34.2413 31.2868 35.4217 30.7558C36.6022 30.2247 37.6568 29.4497 38.5161 28.4817C39.3755 27.5138 40.0201 26.3747 40.4075 25.1397C40.7949 23.9046 40.9164 22.6015 40.7639 21.3161C40.6114 20.0307 40.1884 18.7922 39.5228 17.6821C38.8571 16.5719 37.9639 15.6154 36.9019 14.8753C35.8399 14.1353 34.6333 13.6285 33.3613 13.3884C32.0894 13.1483 30.781 13.1804 29.5223 13.4824L27.084 14.146",
    stroke: "#121212",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFileUploadIcon);
export default __webpack_public_path__ + "static/media/fileUploadIcon.01e29c75a52b0c0db48e8f77da11aa44.svg";
export { ForwardRef as ReactComponent };